// Misc
import React, { Component, Fragment, cloneElement } from 'react'
import PropTypes from 'prop-types'
import withActions from 'react-axios-hoc'
import { withAppSnackbar } from 'atoms/AppSnackbar'

// Validation
import { Validator } from 'react-vld'

// Atoms
import Dialog from 'atoms/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import { AppProgressActivator } from 'atoms/AppProgress'

const mapActionsToProps = ({ onSubmit }) => ({
  submitAction: cancelToken => () => onSubmit(cancelToken)
})

@withActions(mapActionsToProps)
@withAppSnackbar()
class FormDialog extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    closeOnSubmit: PropTypes.bool,
    applyButton: PropTypes.any,
    cancelButton: PropTypes.any,
    children: PropTypes.any,
    showAppSnackbar: PropTypes.func.isRequired,
    submitAction: PropTypes.object.isRequired,
    successMessage: PropTypes.any,
    title: PropTypes.any.isRequired,
    validation: PropTypes.object.isRequired,
  }

  static defaultProps = {
    closeOnSubmit: true,
  }

  componentDidUpdate(prevProps) {
    const { open, submitAction, validation } = this.props
    if (!open && open !== prevProps.open) {
      submitAction.reset({ updateComponent: true })
      validation.reset({ updateComponent: false })
    }
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  handleSubmit = async () => {
    const {
      validation, submitAction, successMessage, showAppSnackbar, onClose, closeOnSubmit
    } = this.props
    const validatorState = validation.validate()
    if (!submitAction.isPending && validatorState.isValid) {
      try {
        await submitAction.run({ updateComponentOnSuccess: false })
        if (successMessage) showAppSnackbar(successMessage)
        if (!this.unmounted && closeOnSubmit) onClose()
      } catch (e) {
        // do nothing
      }
    }
  }

  handleDialogClose = () => {
    const { submitAction, onClose } = this.props
    if (!submitAction.isPending) {
      onClose()
    }
  }

  renderError() {
    const { submitAction } = this.props
    return submitAction.isFailed && (
      <DialogContent>
        <Typography color="error">
          { submitAction.error.message }
        </Typography>
      </DialogContent>
    )
  }

  renderSubmitButton() {
    const { applyButton } = this.props
    return !!applyButton && cloneElement(applyButton, {
      onClick: this.handleSubmit,
      type: 'button',
      color: 'secondary',
      ...applyButton.props,
    })
  }

  renderCancelButton() {
    const { cancelButton } = this.props
    return !!cancelButton && cloneElement(cancelButton, {
      onClick: this.handleDialogClose,
      type: 'button',
      color: 'secondary',
      ...cancelButton.props,
    })
  }

  render() {
    const { open, submitAction, title, children } = this.props
    return (
      <Fragment>
        { submitAction.isPending && <AppProgressActivator /> }
        <Dialog
          fullWidth
          open={open}
          onClose={this.handleDialogClose}
        >
          <Fragment>
            { !!title && <DialogTitle>{ title }</DialogTitle>}
            { children }
            { this.renderError() }
            <DialogActions>
              { this.renderCancelButton() }
              { this.renderSubmitButton() }
            </DialogActions>
          </Fragment>
        </Dialog>
      </Fragment>
    )
  }
}

export default function FormDialogValidator(props) {
  return (
    <Validator>
      { validation => (
        <FormDialog {...props} validation={validation} />
      ) }
    </Validator>
  )
}
